module.exports = "<section class=\"box box--{{ $ctrl.severity.cls }} layout-padding\" ng-if=$ctrl.notification> <div layout=row layout-align=\"start center\"> <div layout=row layout-align=\"start center\"> <i class=\"fa fa-3 {{ $ctrl.severity.icon }}\" aria-hidden=true></i> <div class=space-m-l-m> <div class=md-body-2>{{ $ctrl.notification.subject }}</div> <div class=md-caption>{{ $ctrl.notification.message }}</div> </div> </div> </div> </section>";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/thing-details/alert-box/alert-box.html
// module id = 0//z
// module chunks = 1